import * as CryptoJS from 'crypto-js';

/**
 * Parses URL search params, handling encrypted 'params' parameter.
 * @param {string} search - The search string from location.search
 * @param {boolean} lowerCaseKeys - Whether to lowercase keys
 * @returns {URLSearchParams}
 */
export function parseSearchParams(search: string, lowerCaseKeys = false): URLSearchParams {
  const searchParams = new URLSearchParams(search);

  // Check for encrypted params
  const encryptedParams = searchParams.get('params');
  if (encryptedParams) {
    try {
      const decrypted = CryptoJS.AES.decrypt(encryptedParams, 'z!!!!!!!1sdfadsf56adf456asdfasdf');
      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
      const decryptedParams = new URLSearchParams();
      if (decryptedString.trim().startsWith('{')) {
        const decryptedJson = JSON.parse(decryptedString);
        Object.entries(decryptedJson).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            decryptedParams.set(key, String(value));
          }
        });
      } else {
        const parsed = new URLSearchParams(decryptedString);
        for (const [key, value] of parsed) {
          decryptedParams.set(key, value);
        }
      }
      // Merge decrypted params into searchParams
      for (const [key, value] of decryptedParams) {
        const existingValue = searchParams.get(key);
        if (
          existingValue === null ||
          existingValue === '' ||
          existingValue === 'null' ||
          existingValue === 'undefined'
        ) {
          searchParams.set(key, value);
        }
      }
    } catch (error) {
      console.error('Failed to decrypt params:', error);
    }
  }

  if (!lowerCaseKeys) {
    return searchParams;
  }

  const lowerCaseSearchParams = new URLSearchParams();

  for (const [key, value] of searchParams) {
    lowerCaseSearchParams.set(key.toLowerCase(), value);
  }

  return lowerCaseSearchParams;
}